export let api_url;
export let aqua_base_url;
export let aqua_socket_url;
export let usdt_token;
export let usdr_token;

// USDR converter (USDT <-> USDR 1:1) and its USDT entry id; empty = USDT deposits hidden
export let USDR_CONVERTER_ADDRESS;
export const CONVERTER_USDT_ID = '0x555344542d410000000000000000000000000000000000000000000000000000';
export let OLD_FACTORY_CONTRACT;
export let NEW_FACTORY_CONTRACT;
export let share_pool_dapp;
export let req_liquidity;
export let is_public_live;
export const platform_chainId = 42161;
export const rain_twitter_url = "https://x.com/Rain__Protocol";
export const arbiscan_url = "https://arbiscan.io/tx";
export const IS_DISTRIBUTING_POINT_OPEN = true;
export let ACTIVE_SESSION_TIME;
export const twitter_url = "https://twitter.com/intent/tweet?text";
export const whatsapp_url = "https://wa.me/?text";
export const facebook_url = "https://m.me/?text";
export const telegram_url = "https://t.me/share/url?url";
export const PAYMASTER_ADDRESS = "0x2E1A0D0F605176975cF9dCFC769e371e5C7787C6";
export const ALCHEMY_API_KEY = process.env.REACT_APP_ALCHEMY_API_ID;
export const PAYMASTER_POLICY_ID = process.env.REACT_APP_PAYMASTER_POLICY_ID;
export const ALCHEMY_RPC_URL = `https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}`;
export const IPFS_GATEWAY = `https://ipfs.io/ipfs`;
export let DISPUTE_INITIAL_TIMER;
export let CREATE_DISPUTE_WINDOW_TIMER;
export let IS_AQUA_SWAP_DEPOSIT_ACTIVE = false;
export let IS_AQUA_SWAP_WITHDRAW_ACTIVE = false;
export let IS_BLOGS_ACTIVE;
export let SHARE_MARKET_BASE_URL;
export let SHARE_MARKET;
export let SHARE_PROFILE_BASE_URL;
export let SHARE_PROFILE;
export let RESPONSE_TIME_FOR_CREATOR = 0;
export const RAIN_CONTRACT_ADDRESS = "0xd491076c7316bc28fd4d35e3da9ab5286d079250";
export let RAIN_ARBI_CONTRACT_ADDRESS = "0x25118290e6A5f4139381D072181157035864099d";

export let CRASH_GAME_CONTRACT
export let LIQUIDITY_CONTRACT
export let LIQUIDITY_CLAIM_ADDRESS
export let GRAPH_QL_CRASH
export let RNG_CONTRACT
export let minBetGlobal
export let gameFeePercentage = 0.05

export let SHOW_CRASHGAME;
export let MIN_LIQUIDITY_DISPUTE_CREATION;
export let MIN_LIQUIDITY_APPEAL_CREATION;
// Deployer contract for previewSolvency check (per-env, must match deployed deployer)
export let DEPLOYER_ADDRESS;
// USDR solvency dashboard (per-env), opened from SolvencyLimitModal
export let SOLVENCY_DASHBOARD_URL;
const dev = "development";
const stage = "stage";
const system_ENV = process.env.REACT_APP_ENV;
export let USDT_SYMBOL = "USDR"
// Symbol of USDT markets (the stablecoin before USDR) 
export let USDT_TOKEN_SYMBOL = "USD₮0"
export const BIG_NUMBER_APPROVAL = 1000000000000000000000000000000000000n;
export const PINATA_API_KEY = process.env.REACT_APP_PINATA_API_KEY || "2318bd9b1ee9b9a732ca";
export const PINATA_SECRET_KEY = process.env.REACT_APP_PINATA_SECRET_KEY || "78029869855f6acdef83f4ad97ae6b5a0a1afae8146ee9a086394ae612810731";
export const PINATA_URL = "https://api.pinata.cloud/pinning/pinFileToIPFS";
export let SHOW_GENERATE_MARKETS = false
if (system_ENV === dev) {
    api_url = 'https://dev-api.rain.one';
    aqua_base_url = "https://dev-aqua-backend.quecko.org"
    aqua_socket_url = "wss://dev-aqua-backend.quecko.org"
    OLD_FACTORY_CONTRACT = "0x148DA7F2039B2B00633AC2ab566f59C8a4C86313";
    NEW_FACTORY_CONTRACT = "0x05b1fd504583B81bd14c368d59E8c3e354b6C1dc";
    share_pool_dapp = 'dev-app.rain.one'
    usdt_token = '0xCa4f77A38d8552Dd1D5E44e890173921B67725F4'
    usdr_token = '0x433e7bBeD7b40cB12c3d65702aca2Da60f3F481C'
    USDR_CONVERTER_ADDRESS = '0x58da0C6E3Ad8A1F55735445eff36d1dd5baFdB2c'
    req_liquidity = 0.01
    is_public_live = true
    DISPUTE_INITIAL_TIMER = 5 * 60 // 5 MINUTES
    CREATE_DISPUTE_WINDOW_TIMER = 300 // seconds
    ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1; // ONE DAY
    SHARE_MARKET_BASE_URL = "https://dev-preview.rain.one/"
    SHARE_MARKET = `${SHARE_MARKET_BASE_URL}share/market`
    SHARE_PROFILE_BASE_URL = "https://dev-preview.rain.one/"
    SHARE_PROFILE = `${SHARE_PROFILE_BASE_URL}share/profile`
    RESPONSE_TIME_FOR_CREATOR = 120
    IS_BLOGS_ACTIVE = true
    SHOW_CRASHGAME = true
    CRASH_GAME_CONTRACT = "0xAc512A94Ab0D42E42F57cCB5aF9Ea5Ef7B66e0F1";
    LIQUIDITY_CONTRACT = "0xA83CAfd06DF8b8eB315Ae75F6901Bc2bDcF8B9B4";
    LIQUIDITY_CLAIM_ADDRESS = "0x5844229CFCa32D2378c87601D454DE3C18bf1CFf";
    RNG_CONTRACT = "0xc4C6C3bD65d57032Ea92Ffe36652666E2A746fd1";
    GRAPH_QL_CRASH = "https://api.goldsky.com/api/public/project_cmgzjdpsh00335np2fo348r6u/subgraphs/rain-decision/development/gn"
    minBetGlobal = 0.0001
    RAIN_ARBI_CONTRACT_ADDRESS = '0x43976a124e6834b541840Ce741243dAD3dd538DA'
    USDT_TOKEN_SYMBOL = "USDTm"
    MIN_LIQUIDITY_DISPUTE_CREATION = 0.01
    MIN_LIQUIDITY_APPEAL_CREATION = 0.02
    SHOW_GENERATE_MARKETS = true
    DEPLOYER_ADDRESS = '0xbbDd9F2436d3F2e88588c6d28630557e8066f02f'
    SOLVENCY_DASHBOARD_URL = 'https://dev-rainusdr.quecko.org/dashboard/solvency'
}

else if (system_ENV === stage) {
    api_url = 'https://stg-api.rain.one'
    aqua_base_url = "https://stg-api.aqua.cash"
    aqua_socket_url = "wss://stg-api.aqua.cash"
    OLD_FACTORY_CONTRACT = '0x6109c9f28FE3Ad84c51368f7Ef2d487ca020c561'
    NEW_FACTORY_CONTRACT = "0xD4900CA167228365806FBA4cB21f7EAe8b6d96BE";
    share_pool_dapp = 'stg-app.rain.one'
    usdt_token = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9";
    usdr_token = '0x007724B8C1E5261a7d3d59616060aAc4d2B5C0D4'
    USDR_CONVERTER_ADDRESS = '0x30Aa9B1F42A4897d7eedc89611F58bb687B667F1'
    req_liquidity = 0.01
    is_public_live = true
    DISPUTE_INITIAL_TIMER = 5 * 60 // 5 MINUTES
    CREATE_DISPUTE_WINDOW_TIMER = 300// seconds
    ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1; // ONE DAY
    IS_AQUA_SWAP_WITHDRAW_ACTIVE = true
    SHARE_MARKET_BASE_URL = "https://stg-preview.rain.one/"
    SHARE_MARKET = `${SHARE_MARKET_BASE_URL}share/market`
    SHARE_PROFILE_BASE_URL = "https://stg-preview.rain.one/"
    SHARE_PROFILE = `${SHARE_PROFILE_BASE_URL}share/profile`
    RESPONSE_TIME_FOR_CREATOR = 120
    IS_AQUA_SWAP_DEPOSIT_ACTIVE = true
    IS_BLOGS_ACTIVE = true
    SHOW_CRASHGAME = true
    CRASH_GAME_CONTRACT = "0x5fB8b78844e10E445D01f4D002B71Fac9898B4c0";
    LIQUIDITY_CONTRACT = "0x9D8C968117bDD05eC0377841d55398fE4E1c9E94";
    LIQUIDITY_CLAIM_ADDRESS = "0x26a1dFf8e2C46fAC68847CC50bF08d0a6659adAe";
    RNG_CONTRACT = "0x497939fC514e86772b7a5671A4340421157C86a7";
    GRAPH_QL_CRASH = "https://api.goldsky.com/api/public/project_cmgzjdpsh00335np2fo348r6u/subgraphs/rain-decision/staging/gn"
    minBetGlobal = 0.0001
    MIN_LIQUIDITY_DISPUTE_CREATION = 0.01
    MIN_LIQUIDITY_APPEAL_CREATION = 0.02
    DEPLOYER_ADDRESS = '0x16ccF044f8AE910888d96e9cae6ba22AFEDE628d'
    SOLVENCY_DASHBOARD_URL = 'https://stg-rainusdr.quecko.org/dashboard/solvency'
}

else {
    api_url = 'https://prod-api.rain.one'
    aqua_base_url = "https://prod-api.aqua.cash"
    aqua_socket_url = "wss://prod-api.aqua.cash"
    OLD_FACTORY_CONTRACT = '0xccCB3C03D9355B01883779EF15C1Be09cf3623F1'
    NEW_FACTORY_CONTRACT = "0xA8640B62D755e42C9ed6A86d0fc65CE09e31F264";
    share_pool_dapp = 'rain.one'
    usdt_token = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9";
    usdr_token = '0x007724B8C1E5261a7d3d59616060aAc4d2B5C0D4'
    USDR_CONVERTER_ADDRESS = '0x30Aa9B1F42A4897d7eedc89611F58bb687B667F1'
    req_liquidity = 10
    is_public_live = true
    DISPUTE_INITIAL_TIMER = 24 * 60 * 60 // 24 HOURS
    CREATE_DISPUTE_WINDOW_TIMER = 7200 // seconds
    ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1; // ONE DAY
    IS_AQUA_SWAP_DEPOSIT_ACTIVE = true
    SHARE_MARKET_BASE_URL = "https://preview.rain.one/"
    SHARE_MARKET = `${SHARE_MARKET_BASE_URL}share/market`
    SHARE_PROFILE_BASE_URL = "https://preview.rain.one/"
    SHARE_PROFILE = `${SHARE_PROFILE_BASE_URL}share/profile`
    RESPONSE_TIME_FOR_CREATOR = 24 * 60 * 60
    IS_BLOGS_ACTIVE = false
    SHOW_CRASHGAME = true
    CRASH_GAME_CONTRACT = "0x4E25b638C778Dec7cbF42c6494ea99394aa5d96A";
    LIQUIDITY_CONTRACT = "0x3783c98C39c48750D92A7086D3EacBD231EF26b5";
    LIQUIDITY_CLAIM_ADDRESS = "0x8d854cDa2Ea7FbfE605E62d89DcdcBDba19916F2";
    RNG_CONTRACT = "0x8E4fd92A32036201Ad38b4Ccf37EBdA72e6ad086";
    GRAPH_QL_CRASH = "https://api.goldsky.com/api/public/project_cmgzjdpsh00335np2fo348r6u/subgraphs/rain-decision/production/gn"
    minBetGlobal = 1
    MIN_LIQUIDITY_DISPUTE_CREATION = 10
    MIN_LIQUIDITY_APPEAL_CREATION = 20
    DEPLOYER_ADDRESS = '0x38B3Ba1ee001E6785224E31b3031ae96CA06C677'
    SOLVENCY_DASHBOARD_URL = 'https://usdr.live/dashboard/solvency'
}
